import { useState, useRef } from "react";
import { api, fileUrl } from "@/lib/api";

export default function PortfolioManager({ items, reload }) {
  const empty = { title: "", category: "", description: "", image_path: "", order: 0 };
  const [form, setForm] = useState(empty);
  const [editingId, setEditingId] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [busy, setBusy] = useState(false);
  const fileRef = useRef();

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const startEdit = (it) => {
    setEditingId(it.id);
    setForm({ title: it.title, category: it.category || "", description: it.description || "", image_path: it.image_path || "", order: it.order || 0 });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const reset = () => { setForm(empty); setEditingId(null); if (fileRef.current) fileRef.current.value = ""; };

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      set("image_path", data.path);
    } catch {
      alert("Upload immagine non riuscito.");
    } finally {
      setUploading(false);
    }
  };

  const save = async () => {
    if (!form.title.trim()) { alert("Inserisci un titolo."); return; }
    setBusy(true);
    try {
      if (editingId) await api.put(`/portfolio/${editingId}`, form);
      else await api.post("/portfolio", form);
      reset();
      reload();
    } catch {
      alert("Salvataggio non riuscito.");
    } finally {
      setBusy(false);
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Eliminare questo progetto?")) return;
    await api.delete(`/portfolio/${id}`);
    reload();
  };

  return (
    <div>
      <div className="adm-card">
        <h3>{editingId ? "Modifica progetto" : "Aggiungi progetto"}</h3>
        <div className="adm-grid2">
          <div className="adm-field">
            <label>Titolo *</label>
            <input value={form.title} onChange={(e) => set("title", e.target.value)} placeholder="Es. Rete fibra ottica quartiere Nord" data-testid="pf-title" />
          </div>
          <div className="adm-field">
            <label>Categoria</label>
            <input value={form.category} onChange={(e) => set("category", e.target.value)} placeholder="Es. Telecomunicazioni" data-testid="pf-category" />
          </div>
        </div>
        <div className="adm-field">
          <label>Descrizione</label>
          <textarea rows="3" value={form.description} onChange={(e) => set("description", e.target.value)} placeholder="Breve descrizione del progetto..." data-testid="pf-description" />
        </div>
        <div className="adm-grid2">
          <div className="adm-field">
            <label>Ordine</label>
            <input type="number" value={form.order} onChange={(e) => set("order", Number(e.target.value))} />
          </div>
          <div className="adm-field">
            <label>Immagine</label>
            <div className="adm-upload">
              {form.image_path && <img src={fileUrl(form.image_path)} alt="anteprima" />}
              <input ref={fileRef} type="file" accept="image/*" onChange={upload} data-testid="pf-image-input" />
              {uploading && <p>Caricamento immagine…</p>}
            </div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 12, marginTop: 8 }}>
          <button className="adm-btn" onClick={save} disabled={busy} data-testid="pf-save-btn">
            {editingId ? "Salva modifiche" : "Aggiungi progetto"}
          </button>
          {editingId && <button className="adm-btn ghost" onClick={reset}>Annulla</button>}
        </div>
      </div>

      <div className="adm-card">
        <h3>Progetti pubblicati ({items.length})</h3>
        {items.length === 0 ? (
          <p className="adm-empty">Nessun progetto. Aggiungi il primo qui sopra.</p>
        ) : (
          <div className="adm-pf-list" data-testid="pf-list">
            {items.map((it) => (
              <div className="adm-pf-item" key={it.id}>
                {it.image_path ? <img src={fileUrl(it.image_path)} alt={it.title} /> : <img alt="" />}
                <div className="meta">
                  {it.category && <span className="cat">{it.category}</span>}
                  <h4>{it.title}</h4>
                  <p>{it.description}</p>
                </div>
                <div className="actions">
                  <button className="adm-btn ghost sm" onClick={() => startEdit(it)} data-testid={`pf-edit-${it.id}`}>Modifica</button>
                  <button className="adm-btn danger sm" onClick={() => remove(it.id)} data-testid={`pf-delete-${it.id}`}>Elimina</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
